import { TreeViewBaseItem } from "@mui/x-tree-view";

import {
    InsightsPropertyTree,
    PropertyObjectType,
} from "graphql-types/graphql";
import { getPropertyObjectTypeTranslation } from "utils/translations";

export const formatPropertyTree = (
    properties: InsightsPropertyTree[],
    parentId?: string
): TreeViewBaseItem[] =>
    properties.map((property) => {
        const children = property.children
            ? formatPropertyTree(property.children, property.id)
            : undefined;

        const objectType = getPropertyObjectTypeTranslation(
            property.objectType
        );

        return {
            id: parentId ? `${parentId}-${property.id}` : property.id,
            label: `${property.fullAddress} (${objectType})`,
            children,
        };
    });

export function getAssetBuildings(
    properties: InsightsPropertyTree[]
): InsightsPropertyTree[] {
    const buildings: InsightsPropertyTree[] = [];

    const traverse = (properties: InsightsPropertyTree[]) => {
        properties.forEach((property) => {
            if (property.objectType === PropertyObjectType.BUILDING)
                buildings.push(property);
            if (property.children) traverse(property.children);
        });
    };

    traverse(properties);
    return buildings;
}

export const flat = (arr: InsightsPropertyTree[]): InsightsPropertyTree[] =>
    arr.flatMap((item) => [
        item,
        ...(item.children ? flat(item.children) : []),
    ]);
